// indexedDBService.js
import Dexie from "dexie";
import db from "./db";

export const indexedDBService = {
  getAll: async (collectionName) => await db[collectionName].toArray(),

  add: async (collectionName, item) => await db[collectionName].add(item),

  update: async (collectionName, id, updatedData) =>
    await db[collectionName].update(id, updatedData),

  delete: async (collectionName, id) => await db[collectionName].delete(id),

  clear: async () => {
    await db.close();
    await Dexie.delete(db.name);
  },
};
